module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-angry.e59dae0e.png";